import { render, staticRenderFns } from "./TransactionCancelled.vue?vue&type=template&id=96a6893e&"
import script from "./TransactionCancelled.vue?vue&type=script&lang=js&"
export * from "./TransactionCancelled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports